<footer class="footer">
  <div class="container-fluid">
    <nav>
    </nav>
    <div class="copyright">
      &copy;
      {{test | date: 'yyyy'}},
      <a href="https://rampiere.com" target="_blank">Rampiere</a>
    </div>
  </div>
</footer>